import { observer } from 'mobx-react-lite'
import { ContainerHeader, FullPageWrapper, Tabs, Typography } from 'shared/ui'
import { IntegrationList } from 'pages/settings/pages/integrations/pages/integrationList/IntegrationList'
import {
  IntegrationPageProvider,
  useIntegrationPageContext,
} from 'pages/settings/pages/integrations/context/integrationPageContext'
import { AutomationLogs } from 'pages/settings/pages/integrations/pages/AutomationLogs/AutomationLogs'
import styles from './styles.module.scss'

const IntegrationPageContent = observer(() => {
  const { activeTabKey, setActiveTab, tabs, showLogs } = useIntegrationPageContext()

  return (
    <FullPageWrapper className={styles.container}>
      <ContainerHeader
        customTitle={
          <div className={styles.integrationPageHeader}>
            <Typography variant='heading-lg' ariaLabel='IntegrationPage_title' marginBottom={4}>
              App Marketplace
            </Typography>
            <Typography
              variant='body-md-regular'
              color='var(--content-primary-tertiary)'
              ariaLabel='IntegrationPage_desc'
            >
              Connect Salesmsg to your favorite tools
            </Typography>
          </div>
        }
        titleVariant='heading-lg'
        paddingTop={64}
        paddingBottom={56}
        height={116}
        isAutoHeight
      />
      {showLogs && (
        <div className={styles.tabs}>
          <Tabs
            variant='divider'
            tabs={tabs}
            activeTabKey={activeTabKey}
            handleSelectTab={setActiveTab}
          />
        </div>
      )}
      {activeTabKey === 'integrations' && <IntegrationList />}
      {activeTabKey === 'automationLogs' && showLogs && <AutomationLogs />}
    </FullPageWrapper>
  )
})

export const IntegrationPage = () => (
  <IntegrationPageProvider>
    <IntegrationPageContent />
  </IntegrationPageProvider>
)
